export default {
  states: '',
  departments: '',
  functions: '',
  roles: '',
  marital_status: '',
  genders: '',
  months_of_the_year: '',
  authorizations: '',
  permissions: '',
  status: '',
  paychecks: '',
  workstations: '',
  user_types: '',
  employees: '',
  scale_types: '',
  user_documents_types: '',
}
